module.exports = __webpack_public_path__ + "media/images/pic/calendar-1a530612a8c01bcddc7a4cf01610d9aa.svg";